module.exports = __webpack_public_path__ + "img/plusWhite.5f7c66b9.svg";